export const newsList = [
  {
    id: 'n-5001',
    title: '湖人主场鏖战勇士，末节攻防大战悬念拉满',
    category: '赛事新闻',
    date: '2026-10-12',
    author: '篮球比分编辑部',
    summary: '湖人与勇士的焦点战进入白热化阶段，双方在第三节后段展开拉锯，比分交替领先，比赛悬念被保留到最后时刻。',
    cover: 'https://readdy.ai/api/search-image?query=Dramatic%20indoor%20basketball%20arena%20with%20warm%20orange%20spotlights%20over%20a%20wooden%20court%2C%20blurred%20crowd%20in%20dark%20tones%2C%20cinematic%20sports%20photography%2C%20high%20contrast%2C%20energetic%20atmosphere&width=800&height=500&seq=bball-news-01&orientation=landscape',
    content: [
      '北京时间今天上午，一场备受瞩目的西部焦点战在洛杉矶打响。主队与客队从开局便展开激烈对攻，首节双方命中率均超过五成，比分始终没有拉开。',
      '进入第二节，客队依靠外线连续命中三分一度取得领先，但主队核心球员挺身而出，用稳定的中距离跳投和篮下强攻帮助球队紧咬比分。半场结束时，双方仅有一球之差。',
      '易边再战，比赛强度进一步提升。主队在防守端加强了对对方持球人的施压，多次完成抢断并转化为快攻得分；客队则凭借耐心的传导球寻找空位机会，比赛进入白热化的拉锯阶段。',
      '截至第三节后段，双方比分依然胶着。从技术统计来看，主队在篮板球和禁区得分上略占优势，客队则在三分命中数上领先，比赛的胜负很可能取决于末节的临场发挥与罚球稳定性。',
      '赛后数据与详细技术统计将持续更新，敬请关注篮球比分网站的实时比分与比赛详情页面。',
    ],
    relatedMatchId: 'm-1001',
    relatedTeamIds: ['nba-lakers', 'nba-warriors'],
  },
  {
    id: 'n-5002',
    title: '凯尔特人轻取掘金，锋线群发挥出色',
    category: '赛事新闻',
    date: '2026-10-11',
    author: '篮球比分编辑部',
    summary: '凯尔特人主场以 118-109 击败掘金，全队三分球手感火热，锋线球员多点开花奠定胜局。',
    cover: 'https://readdy.ai/api/search-image?query=Modern%20basketball%20arena%20interior%20with%20green%20and%20white%20lighting%2C%20empty%20polished%20hardwood%20court%2C%20clean%20minimal%20sports%20architecture%20photography%2C%20soft%20ambient%20glow&width=800&height=500&seq=bball-news-02&orientation=landscape',
    content: [
      '在 TD 花园球馆进行的一场常规赛中，主队以 118-109 战胜来访的掘金队，收获一场含金量十足的胜利。',
      '主队全场三分球 45 投 18 中，命中率超过四成。锋线球员在进攻端承担了主要得分任务，不仅外线投射稳定，还多次冲击篮下制造杀伤。',
      '客队方面，中锋在高位策应与低位进攻中表现亮眼，一度带领球队在第二节实现反超，但球队全场出现 15 次失误，成为落败的主要原因之一。',
      '赛后主队主教练表示，球队在防守轮转和篮板保护上的执行力值得肯定，接下来需要继续保持专注，迎接密集的赛程。',
    ],
    relatedMatchId: 'm-1002',
    relatedTeamIds: ['nba-celtics', 'nba-nuggets'],
  },
  {
    id: 'n-5003',
    title: '辽宁广东强强对话，内线对抗成为胜负关键',
    category: '赛后分析',
    date: '2026-10-12',
    author: '篮球比分编辑部',
    summary: 'CBA 两支传统豪强正面交锋，双方均以高强度防守立足，内线篮板与二次进攻的争夺将直接影响比赛走向。',
    cover: 'https://readdy.ai/api/search-image?query=Intense%20basketball%20game%20under%20bright%20red%20and%20white%20arena%20lights%2C%20motion%20blur%20of%20players%20competing%20for%20rebound%2C%20dramatic%20sports%20photography%2C%20warm%20tone%2C%20high%20energy&width=800&height=500&seq=bball-news-03&orientation=landscape',
    content: [
      'CBA 常规赛迎来一场重量级对话，两支传统强队狭路相逢，比赛从第一节开始便充满火药味。',
      '双方均以防守见长，比赛节奏相对克制。首节双方得分都不高，但在篮板球的争夺上格外激烈，多次出现多人拼抢的地板球。',
      '主队的内线球员在禁区对抗中占据上风，凭借身高与力量优势完成了多次二次进攻；客队则依靠快速的外线传导寻找三分机会，努力缩小分差。',
      '从战术层面看，这场比赛的胜负手很可能是内线的篮板控制。谁能更好地保护好后场篮板、限制对手的二次进攻，谁就更有机会掌握比赛主动权。',
    ],
    relatedMatchId: 'm-1005',
    relatedTeamIds: ['cba-liaoning', 'cba-guangdong'],
  },
  {
    id: 'n-5004',
    title: '联盟交易动态：多支球队寻求阵容补强',
    category: '转会消息',
    date: '2026-10-10',
    author: '篮球比分编辑部',
    summary: '随着赛季深入，多支处于季后赛边缘的球队开始评估阵容，围绕锋线与替补控卫的补强需求日益明显。',
    cover: 'https://readdy.ai/api/search-image?query=Abstract%20sports%20management%20concept%2C%20basketball%20on%20a%20dark%20wooden%20desk%20with%20blurred%20orange%20arena%20lights%20in%20background%2C%20professional%20editorial%20photography%2C%20moody%20tone&width=800&height=500&seq=bball-news-04&orientation=landscape',
    content: [
      '据多家媒体报道，随着赛季进入中段，多支球队的管理层正在积极评估现有阵容，寻求通过交易补强薄弱环节。',
      '从需求分布来看，具备三分投射能力的锋线和能够稳定组织的替补控卫成为市场上的热门类型，多支冲冠球队都希望增加这类即战力。',
      '与此同时，一些处于重建期的球队则更倾向于积累年轻球员与选秀权，为长期发展做准备。双方诉求的差异，为交易谈判提供了空间。',
      '需要提醒的是，本页面内容为演示示例，相关转会信息仅供参考，具体以官方公告为准。',
    ],
    relatedTeamIds: ['nba-heat', 'nba-mavericks'],
  },
  {
    id: 'n-5005',
    title: '王牌队总决赛再下一城，总比分领先',
    category: '赛事新闻',
    date: '2026-10-09',
    author: '篮球比分编辑部',
    summary: 'WNBA 总决赛第三场，王牌队主场 92-85 战胜自由人，在系列赛中占据主动。',
    cover: 'https://readdy.ai/api/search-image?query=Bright%20modern%20basketball%20arena%20with%20black%20and%20gold%20accents%2C%20spotlight%20beams%20over%20the%20court%2C%20elegant%20sports%20event%20photography%2C%20clean%20composition&width=800&height=500&seq=bball-news-05&orientation=landscape',
    content: [
      'WNBA 总决赛移师拉斯维加斯进行第三场较量，主队顶住压力，以 92-85 击败对手，在系列赛中取得领先。',
      '本场比赛主队核心球员发挥稳定，贡献全队最高的得分与篮板，在攻防两端都展现出统治力。球队全场送出 24 次助攻，团队配合流畅。',
      '客队虽然在外线手感不俗，但在篮板球和失误控制上稍逊一筹，未能在关键回合顶住主队的冲击。',
      '系列赛悬念仍在，第四场比赛将在纽约进行，客队需要尽快调整状态，力争扳回一城。',
    ],
    relatedMatchId: 'm-1009',
    relatedTeamIds: ['wnba-aces', 'wnba-liberty'],
  },
  {
    id: 'n-5006',
    title: '战术解析：现代篮球的空间与投射革命',
    category: '赛后分析',
    date: '2026-10-08',
    author: '篮球比分编辑部',
    summary: '从挡拆外弹到五外阵容，现代篮球的进攻体系愈发强调空间拉开与三分效率，本文带你快速理解背后的逻辑。',
    cover: 'https://readdy.ai/api/search-image?query=Clean%20top%20down%20view%20of%20a%20basketball%20half%20court%20with%20tactical%20markings%2C%20minimal%20graphic%20style%2C%20warm%20orange%20and%20white%20color%20scheme%2C%20modern%20sports%20analysis%20aesthetic&width=800&height=500&seq=bball-news-06&orientation=landscape',
    content: [
      '过去十年，篮球战术经历了显著的演变，空间与投射的重要性被提升到前所未有的高度。',
      '挡拆外弹（pick and pop）让内线球员具备拉开空间的能力，迫使防守方扩大防守范围；而五外阵容则通过场上的每一名球员都具备三分威胁，最大化进攻空间。',
      '数据统计显示，三分球的期望得分效率显著高于中距离跳投，这也是各队持续增加三分出手比例的重要原因。',
      '当然，战术的进化并不意味着内线价值消失。篮板保护、护框能力和禁区终结依然是比赛胜负的重要组成部分，攻守平衡才是强队的共同特征。',
    ],
    relatedTeamIds: ['nba-warriors', 'nba-bucks'],
  },
  {
    id: 'n-5007',
    title: '伤病速递：多名球员进入每日观察名单',
    category: '赛事新闻',
    date: '2026-10-07',
    author: '篮球比分编辑部',
    summary: '联盟多支球队更新伤病报告，部分主力球员因轻微伤情进入每日观察名单，出场状态有待赛前确认。',
    cover: 'https://readdy.ai/api/search-image?query=Empty%20basketball%20locker%20room%20with%20warm%20lighting%2C%20jerseys%20hanging%20neatly%2C%20clean%20professional%20editorial%20photography%2C%20soft%20shadows%2C%20muted%20warm%20tones&width=800&height=500&seq=bball-news-07&orientation=landscape',
    content: [
      '随着赛程逐渐密集，多支球队在本周更新了伤病报告，对阵容轮换产生了一定影响。',
      '据球队公布的名单，部分主力球员因轻微脚踝与膝盖不适进入每日观察状态，是否出战将在赛前根据训练情况决定。',
      '教练组表示，球队会根据球员的身体状况合理安排上场时间，避免在高强度赛程中出现更严重的伤病问题。',
      '本页面伤病信息为演示示例，实际伤停情况请以球队官方公布为准。',
    ],
    relatedTeamIds: ['nba-suns', 'nba-nuggets'],
  },
  {
    id: 'n-5008',
    title: '欧洲篮球联赛：皇马主场延续不败势头',
    category: '赛事新闻',
    date: '2026-10-10',
    author: '篮球比分编辑部',
    summary: 'EuroLeague 常规赛，皇家马德里主场 89-81 击败巴塞罗那，继续稳居积分榜首位。',
    cover: 'https://readdy.ai/api/search-image?query=Elegant%20European%20indoor%20basketball%20arena%20with%20white%20and%20gold%20lighting%2C%20polished%20court%2C%20sophisticated%20sports%20architecture%20photography%2C%20warm%20neutral%20tone&width=800&height=500&seq=bball-news-08&orientation=landscape',
    content: [
      '在欧洲篮球联赛的一场焦点战中，皇家马德里坐镇主场，以 89-81 战胜老对手巴塞罗那。',
      '主队全场保持领先，攻防两端都展现出了极高的战术素养。球队的团队配合尤为出色，全场送出 21 次助攻，失误仅有 9 次。',
      '客队虽然在第三节一度将分差缩小到 5 分以内，但主队凭借稳定的罚球和关键防守稳住局面，最终有惊无险地拿下比赛。',
      '此役过后，皇家马德里继续稳居联赛榜首，展现出强劲的争冠状态。',
    ],
    relatedMatchId: 'm-1007',
    relatedTeamIds: ['euro-real', 'euro-barca'],
  },
  {
    id: 'n-5009',
    title: '球员专栏：从数据看本赛季 MVP 竞争格局',
    category: '赛后分析',
    date: '2026-10-06',
    author: '篮球比分编辑部',
    summary: '得分、篮板、助攻与球队战绩的综合表现，让本赛季最有价值球员的竞争格外激烈，本文盘点主要候选人。',
    cover: 'https://readdy.ai/api/search-image?query=Close%20up%20of%20a%20basketball%20on%20a%20dark%20reflective%20surface%20with%20warm%20orange%20rim%20lighting%2C%20dramatic%20product%20photography%2C%20moody%20atmosphere%2C%20high%20detail&width=800&height=500&seq=bball-news-09&orientation=landscape',
    content: [
      '随着赛季过半，最有价值球员的竞争逐渐明朗，几位候选人在数据与球队战绩上各具优势。',
      '从基础数据来看，几位球星在得分、篮板、助攻等指标上名列前茅；但 MVP 的评选往往还要综合考虑球队战绩、关键场次表现以及攻防两端的贡献。',
      '除了个人数据，球员对球队整体进攻体系的带动作用也越来越受到重视。一名能够提升队友表现、在关键时刻挺身而出的球员，更容易获得评委的青睐。',
      '接下来的赛程将是对各位候选人的重要考验，谁能带领球队取得更好的成绩，谁就更有可能笑到最后。',
    ],
    relatedTeamIds: ['nba-nuggets', 'nba-bucks'],
  },
];